import {
  INITIALIZE_CONFIGURATOR_SUCCESS,
} from './initializeConfiguratorRequest';

export const initializeConfiguratorSuccess = () => ({
  type: INITIALIZE_CONFIGURATOR_SUCCESS,
  payload: {
  },
});
